import { replace } from 'react-router-redux';
import moment from 'moment';
import _ from 'lodash';

import getDatabase from 'Common/DB';
import { getDatabaseName } from 'State/selectors';
import { loading, error } from 'State/actions';
import * as POSSelectors from 'PointOfSale/selectors';
import { POS_ROUTES } from 'PointOfSale/modules/common/constants';
import {
  resetQueue,
  addToQueue,
} from 'PointOfSale/modules/queue/state/actions';
import { clearCurrentProfile } from 'PointOfSale/modules/individualServing/state/actions';
import { writeTransaction } from 'PointOfSale/state/actions';
import * as types from 'PointOfSale/modules/cepCard/state/types';
import { MealTypesEnum } from 'Common/Constants/Enumeration/MealTypesEnum';
import { TransactionTypeEnum } from 'Common/Constants/Enumeration/TransactionTypeEnum';
import {
  DATE_FORMAT_TRANSACTION_HISTORY,
  GENERIC_ACCOUNTS,
} from 'Common/Constants';
import {
  getItemPricingForGrade,
  getItemConvertAmountForGrade,
  getPriceForStatus,
} from 'PointOfSale/modules/common/helpers';

export const incrementServedMealsCount = count => ({
  type: types.INCREMENT_SERVED_MEALS_COUNT,
  payload: count,
});

export const incrementProcessedMealsCount = count => ({
  type: types.MEAL_COUNTER_INCREMENT_PROCESSED_MEAL_COUNTS,
  payload: count,
});

export const selectStudent = student => (dispatch, getState) => {
  dispatch(resetQueue());
  dispatch(replace(`${POS_ROUTES.QUEUE}/${student.Id}`));
  dispatch(addToQueue(student));
};

export const removeStudent = () => (dispatch, getState) => {
  dispatch(resetQueue());
  dispatch(clearCurrentProfile());
  dispatch(replace(POS_ROUTES.MEAL_COUNTER));
};

export const reset = () => ({
  type: types.MEAL_COUNTER_RESET,
});

export const checkout = () => async (dispatch, getState) => {
  try {
    const state = getState();
    const databaseName = getDatabaseName(state);
    const DB = await getDatabase(databaseName);

    dispatch(loading(types.MEAL_COUNTER_LOADING, true));

    const selectedSiteDetails = POSSelectors.getSelectedSiteDetails(state);
    const currentSelectedMenu = POSSelectors.getCurrentSelectedMenu(state);
    const qsi = POSSelectors.getQuickServeItem(state);
    const selectedDate = POSSelectors.getSelectedDate(state);

    const servedMealsCount = POSSelectors.getServedMealsCount(state);
    const processedMealsCount = POSSelectors.getProcessedMealsCount(state);

    const Qty = servedMealsCount - processedMealsCount;
    const date = moment(selectedDate).isValid()
      ? moment(selectedDate)
      : moment();
    const PrimarySiteId = selectedSiteDetails.Id;
    const MealType = MealTypesEnum[currentSelectedMenu];
    const WorkingDT = moment(date).format(DATE_FORMAT_TRANSACTION_HISTORY);

    const item = await DB.ServedItems.where({
      ItemId: qsi.ItemId,
      SiteId: PrimarySiteId,
    }).first();

    const StudentId = GENERIC_ACCOUNTS.STATUS_2;
    const GenericStatus2Account = await DB.Students.where({
      Id: StudentId,
    }).first();

    const Pricing = getItemPricingForGrade(item);

    const Price = _.multiply(
      getPriceForStatus(Pricing, GenericStatus2Account.StatusCurrent),
      Qty
    );

    const { Converted, ConvertAmount } = getItemConvertAmountForGrade(item);

    const StateReimbursable = Pricing.StateReimbursable;

    const BoughtItems = [
      {
        ItemId: item.ItemId,
        Description: item.Description,
        NutritionCode: item.NutritionCode,
        StateReimbursable,
        Price,
        Qty,
        Converted,
        ConvertAmount,
      },
    ];

    const StudentIdSeed = GenericStatus2Account.IdSeed;

    const transaction = {
      TransactionType: TransactionTypeEnum.Cash,
      AmountPaid: 0,
      PrimarySiteId,
      MealType,
      StudentIdSeed,
      BoughtItems,
      WorkingDT,
    };

    const [written, err] = await dispatch(writeTransaction(transaction));

    if (err) {
      throw err;
    }
    if (written) {
      dispatch(incrementProcessedMealsCount(Qty));
    }
  } catch (err) {
    error(types.MEAL_COUNTER_ERROR, err);
  } finally {
    dispatch(loading(types.MEAL_COUNTER_LOADING, false));
  }
};



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/cepCard/state/actions.js